import { memo, useCallback } from 'react';
import { Accordion, AccordionDetails, Typography } from '@mui/material';
import SectionLayout from 'components/common/SectionLayout';
import { ErrorForBtn, RadioBox } from 'components';
import { BidValue } from './BidValue';
import { DailyBudgetValue } from './DailyBudgetValue';
// import { Cpm } from './Cpm';
// import { isAdminSelector } from 'store/selectors';
import { campaignEnvironment } from 'constants';
import { useFacade2 } from './useFacade2';

import * as S from './BiddingSection.styled';

const BiddingSection = ({ environment, isOpen }) => {
  const {
    handleBidTypeChange,
    expandedFlag,
    // errorFlag,
    errorBorderFlag,
    bidType,
    isOnBoarding,
    showFlag,
    budgetValue,
    acquireNewUserGoal,
    reEngageGoal,
    isWebsite,
    isCpmBtn,
    minBidValue,
    maxBidValue,
    minDailyBudget,
    maxDailyBudget,
    isCpm,
    minBidValueStore,
    isAdmin,
    minimumBudget,
    applicableRule,
    budgetRuleError,
  } = useFacade2(environment);

  // const isAdmin = useSelector(isAdminSelector);
  // const currentSelectedApps = useSelector(
  //   (store) => store?.general?.mainCampaignObject?.currently_selected_apps,
  // );
  // const currentCpmItemsArray = useSelector(
  //   (store) => store?.general?.mainCampaignObject?.currentCampaignObj?.campaignBiddings,
  // );

  // const isCpm =
  //   !isOnBoarding &&
  //   acquireNewUserGoal &&
  //   isAdmin &&
  //   selectedLocations?.length > 0 &&
  //   currentSelectedApps?.length > 0;

  const radioBoxIsDisabled = useCallback(
    (label) => {
      if (environment === campaignEnvironment.new_empty) {
        if (label === 'CPM' && !isCpmBtn) {
          return true;
        }
        // if (label === 'CPM' && targetType !== 2) {
        //   console.log('here');
        //   return true;
        // }
        if (label === 'CPI' && isWebsite) {
          return true;
        }
        if (label !== 'CPM') {
          return Boolean(isOnBoarding);
        }
        return false;
      }
      if (
        environment === campaignEnvironment.edit ||
        environment === campaignEnvironment.duplicate
      ) {
        const conditions = {
          CPC: +bidType !== 2,
          CPI: +bidType !== 3,
          CPM: +bidType !== 1,
          // CPI: (isCpmSelected && isCpm) || +bidType !== 3,
          // CPM: !isCpmSelected || +bidType !== 3,
        };
        return conditions[label] ?? true;
      }
      return true;
    },
    // [isOnBoarding, bidType, environment, targetType, isCpmBtn],
    [isOnBoarding, bidType, environment, isCpmBtn, isWebsite],
  );

  const radioBoxIsPressed = useCallback(
    (label) => {
      const conditions = {
        CPC: +bidType === 2,
        CPI: +bidType === 3,
        CPM: +bidType === 1,
        // CPI: +bidType === 3 && (!isCpmSelected || !isCpm),
        // CPM: +bidType === 3 && isCpmSelected,
      };
      return conditions[label] ?? true;
    },
    [bidType],
  );

  // const isDisabledCPI =
  //   isOnBoarding ||
  //   (environment === campaignEnvironment.edit && isCpmSelected && isCpm) ||
  //   (environment === campaignEnvironment.edit && +bidType !== 3) ||
  //   (environment === campaignEnvironment.duplicate && isCpmSelected && isCpm) ||
  //   (environment === campaignEnvironment.duplicate && +bidType !== 3);

  // const isDisabledCPC =
  //   isOnBoarding ||
  //   (environment === campaignEnvironment.edit && +bidType !== 2) ||
  //   (environment === campaignEnvironment.duplicate && +bidType !== 2);
  // const isDisabledCPM =
  //   isOnBoarding ||
  //   (environment === campaignEnvironment.edit && !isCpmSelected) ||
  //   (environment === campaignEnvironment.edit && +bidType !== 3) ||
  //   (environment === campaignEnvironment.duplicate && !isCpmSelected) ||
  //   (environment === campaignEnvironment.duplicate && +bidType !== 3);

  return (
    <S.Container>
      <Accordion expanded={expandedFlag}>
        <SectionLayout
          topPadding='8'
          leftSide={
            <>
              <Typography variant='subtitle2'>Bid Type:</Typography>
              <Typography variant='subtitle1'>CPI - Cost Per Install</Typography>
              <Typography variant='subtitle1'>CPC - Cost Per Click</Typography>
              <Typography variant='subtitle1'>CPM - Cost Per Thousand Impressions</Typography>
            </>
          }
          rightSide={
            <>
              <S.RadioBoxGroup
                showborder={errorBorderFlag.toString()}
                disabled={
                  environment === campaignEnvironment.edit ||
                  environment === campaignEnvironment.duplicate
                }
              >
                {showFlag ? (
                  <>
                    <RadioBox.NormalSize
                      label='CPI'
                      width={76}
                      variant='left'
                      value={3}
                      onChange={handleBidTypeChange}
                      pressed={radioBoxIsPressed('CPI')}
                      disabled={radioBoxIsDisabled('CPI')}
                      //disabled={isDisabledCPI}
                    />
                    <RadioBox.NormalSize
                      label='CPC'
                      width={76}
                      variant={'center'}
                      value={2}
                      onChange={handleBidTypeChange}
                      pressed={radioBoxIsPressed('CPC')}
                      disabled={radioBoxIsDisabled('CPC')}
                      //disabled={isDisabledCPC}
                    />
                    {/* {isCpm && ( */}
                    <RadioBox.NormalSize
                      label='CPM'
                      width={76}
                      variant='right'
                      value={1}
                      onChange={handleBidTypeChange}
                      pressed={radioBoxIsPressed('CPM')}
                      disabled={radioBoxIsDisabled('CPM')}
                      //disabled={isDisabledCPM}
                    />
                    {/* )} */}
                  </>
                ) : (
                  (acquireNewUserGoal && <S.Text>CPI</S.Text>) ||
                  (reEngageGoal && <S.Text>CPC</S.Text>)
                )}
              </S.RadioBoxGroup>
              <ErrorForBtn errorMsg='This field is required.' isOpen={errorBorderFlag} />
            </>
          }
        />

        {/* {isCpm && isCpmSelected && (
          <Cpm
            onUpdateCpm={handleUpdateCpm}
            appList={currentSelectedApps}
            cpmList={currentCpmItemsArray}
            countriesList={selectedLocations}
            onHandleUpdateCpm={handleUpdateCpm}
            environment={environment}
            errorFlag={errorFlag}
          />
        )} */}
        <AccordionDetails>
          <BidValue
            isAdmin={isAdmin}
            // isOpen={isOpen}
            minBidValue={minBidValue}
            maxBidValue={maxBidValue}
            isCpm={isCpm}
            minBidValueStore={minBidValueStore}
          />
          <DailyBudgetValue
            isOpen={isOpen}
            value={budgetValue}
            minDailyBudget={minDailyBudget}
            maxDailyBudget={maxDailyBudget}
            minimumBudget={minimumBudget}
            applicableRule={applicableRule}
            budgetRuleError={budgetRuleError}
          />
        </AccordionDetails>
      </Accordion>
    </S.Container>
  );
};

export default memo(BiddingSection);
